import { render, staticRenderFns } from "./secondary-button.vue?vue&type=template&id=0398ba36&scoped=true"
import script from "./secondary-button.vue?vue&type=script&lang=js"
export * from "./secondary-button.vue?vue&type=script&lang=js"
import style0 from "./secondary-button.vue?vue&type=style&index=0&id=0398ba36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0398ba36",
  null
  
)

export default component.exports